var _rect, _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextBgDesk = function SvgTextBgDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 599,
    height: 374,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 431,
    x: 24,
    y: 45,
    fill: "url(#text-bg-desk_svg__a)",
    rx: 26.19,
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 250,
    x: 576,
    y: -89,
    fill: "url(#text-bg-desk_svg__b)",
    rx: 26.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#904CFF",
    strokeWidth: 3,
    d: "M5.784 152.17 23.78 121l17.996 31.17z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599,
    cy: 311,
    r: 23.636,
    stroke: "#904CFF",
    strokeWidth: 4.727
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-desk_svg__a",
    x1: 324,
    x2: 324,
    y1: 45,
    y2: 476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#3520F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#6521C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-desk_svg__b",
    x1: 656.5,
    x2: 656.5,
    y1: -89,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#8000E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#5334F4"
  })))));
};
export { SvgTextBgDesk as ReactComponent };